import proxybase from './proxybase';

class AcademyService {
  getAcademyCourses() {
    return proxybase
      .get(`/academy/getAcademyCourses`)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  getStudentProgress(body) {
    return proxybase
      .post(`/academy/getStudentProgress`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  addStudentProgress(body) {
    return proxybase
      .post(`/academy/addStudentProgress`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  // New methods for course and lesson management
  createCourse(body) {
    return proxybase
      .post(`/academy/createCourse`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  updateCourse(courseId, body) {
    return proxybase
      .put(`/academy/updateCourse/${courseId}`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  deleteCourse(courseId) {
    return proxybase
      .delete(`/academy/deleteCourse/${courseId}`)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  createLesson(body) {
    return proxybase
      .post(`/academy/createLesson`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  updateLesson(lessonId, body) {
    return proxybase
      .put(`/academy/updateLesson/${lessonId}`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  deleteLesson(lessonId) {
    return proxybase
      .delete(`/academy/deleteLesson/${lessonId}`)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  uploadLessonFile(file, lessonId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('lessonId', lessonId);

    return proxybase
      .post(`/academy/uploadLessonFile`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  getLessonComments(body) {
    return proxybase
      .post(`/academy/getLessonComments`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  sendLessonComment(body) {
    return proxybase
      .post(`/academy/sendLessonComment`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  deleteLessonComment(body) {
    return proxybase
      .post(`/academy/deleteLessonComment`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
const academyService = new AcademyService();
export default academyService;
